/**
 * Primary card action: Launch / Request access / Pending / Re-request
 */

import React from 'react';
import { ExternalLink, Lock, Clock } from 'lucide-react';

export function getToolAccessButtonState(accessStates, toolId) {
  return accessStates?.[toolId]?.buttonState || 'launch';
}

const ToolAccessPrimaryButton = ({
  tool,
  accessStates,
  onLaunch,
  onRequestAccess,
  className = 'garage-tool-btn garage-tool-btn-primary',
}) => {
  const state = getToolAccessButtonState(accessStates, tool.id);
  const rejectionReason = accessStates?.[tool.id]?.rejectionReason;

  if (state === 'pending') {
    return (
      <button type="button" className={`${className} garage-tool-btn-pending`} disabled>
        <Clock size={14} />
        Request pending
      </button>
    );
  }

  if (state === 'request' || state === 'rerequest') {
    return (
      <button
        type="button"
        className={`${className} garage-tool-btn-request`}
        onClick={(e) => {
          e.stopPropagation();
          onRequestAccess(tool);
        }}
        title={rejectionReason || undefined}
      >
        <Lock size={14} />
        {state === 'rerequest' ? 'Re-request' : 'Request access'}
      </button>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        onLaunch(tool);
      }}
    >
      <ExternalLink size={14} />
      Launch
    </button>
  );
};

export default ToolAccessPrimaryButton;
